export default "__VITE_PUBLIC_ASSET__23df9ab6__"